// extracted by mini-css-extract-plugin
module.exports = {"disableTextColor":"UsersPage_disableTextColor__2UMEd"};